import ApiClient from "../../api-client";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import { toast } from "react-toastify";
import "./forgotpassword.css";

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const role = 'admin';

  const validate = () => {
    const errors = {};
    if (!email) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = "Email address is invalid";
    }
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      try {
        const result = await ApiClient.post('api/users/emailverification', { email, role });

        if (result.status === true) {
          toast.success(result.message, { autoClose: 1000 });
          navigate("/verify-otp", { state: { email } });
        } else {
          toast.error(result.message, { autoClose: 1000 });
        }
      } catch (error) {
        toast.error(error.message, { autoClose: 3000 });
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2 className="mb-10">Welcome</h2>
        <div className="login-logo">Admin</div>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label className="label-text" for="email">
              Email
            </Label>
            <Input
              type="email"
              name="email"
              id="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyPress={handleKeyPress}
            />
            {errors.email && (
              <div className="error-message">{errors.email}</div>
            )}
          </FormGroup>

          <Button type="submit" className="login-button">
            Submit
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default ForgotPassword;
